"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountController = void 0;
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var AccountController = (function () {
    function AccountController(createUi, make, user, rolesService, usingFeature) {
        this.ui = createUi(require("./Account.html"));
        if (rolesService.isAdmin(user)) {
            var changeCompanyDetails = make(require("./ChangeCompanyDetails/ChangeCompanyDetails"));
            this.ui.changeCompanyDetails = changeCompanyDetails.ui;
            var setDefaultAccess = make(require("./SetDefaultAccess/SetDefaultAccess"));
            this.ui.setDefaultAccess = setDefaultAccess.ui;
            var setInvitePermission = make(require("./SetInvitePermission/SetInvitePermission").SetInvitePermissionController);
            this.ui.setInvitePermission = setInvitePermission.ui;
            if (usingFeature(FeatureFlag_1.default.IpFiltering) && usingFeature(FeatureFlag_1.default.GrandfatherIPFiltering)) {
                var officeIpFilters = make(require("./OfficeIpFilters/OfficeIpFilters"));
                this.ui.officeIpFilters = officeIpFilters.ui;
            }
        }
    }
    return AccountController;
}());
exports.AccountController = AccountController;
